export const baseUrl = "mein-remindme";
export const DashboardRoute = `/${baseUrl}`;

export const DashboardPrizesRoute = `/${baseUrl}/praemien`;
export const DashboardQuestionsAndAnswersRoute = `/fragen-und-antworten`;
